import { render, staticRenderFns } from "./QueryAuctionDetailModal.vue?vue&type=template&id=2a5ad140&"
import script from "./QueryAuctionDetailModal.vue?vue&type=script&lang=ts&"
export * from "./QueryAuctionDetailModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports